import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { apiUsersList, apiUsersView } from 'Services/AdminService'
import { dataDefault } from 'Views/Admin/Users/CollectionPoint'

export const getData = createAsyncThunk('admin/users/getData', async datas => {
    const { data } = await apiUsersList(datas)
    return data
})

export const getView = createAsyncThunk('admin/users/getView', async id => {
    if (!id) return viewData
    const { data } = await apiUsersView(id)
    data.phone = data.phone ?? ''
    data.image = ''
    data.collection_points =
        data.collection_points && data.collection_points.length !== 0 ? data.collection_points : [dataDefault]
    return data
})

const viewData = {
    first_name: '',
    last_name: '',
    email: '',
    phone: '',
    password: '',
    password_confirmation: '',
    image: '',
    collection_points: [dataDefault],
}

export const usersSlice = createSlice({
    name: 'admin/users',
    initialState: {
        loading: true,
        view: viewData,
        data: [],
        total: 0,
        table: {
            page: 1,
            length: 10,
            search: '',
            column: '',
            dir: '',
            status: '1',
            verified: '1',
        },
    },
    reducers: {
        setData: (state, { payload }) => {
            state.data = payload
        },
        setTableData: (state, { payload }) => {
            state.table = payload
        },
        setStatus: (state, { payload }) => {
            state.table.page = 1
            state.table.status = payload
        },
        setVerified: (state, { payload }) => {
            state.table.page = 1
            state.table.verified = payload
        },
    },
    extraReducers: builder => {
        builder
            .addCase(getData.pending, state => {
                state.loading = true
            })
            .addCase(getData.fulfilled, (state, { payload }) => {
                state.loading = false
                state.data = payload.data
                state.total = payload.total
            })
            .addCase(getData.rejected, state => {
                state.loading = false
                state.data = []
                state.total = 0
            })
            .addCase(getView.pending, state => {
                state.loading = true
                state.view = viewData
            })
            .addCase(getView.fulfilled, (state, { payload }) => {
                state.loading = false
                state.view = payload
            })
    },
})

export const { setData, setTableData, setStatus, setVerified } = usersSlice.actions

export default usersSlice.reducer
